import { Box, Button, Checkbox, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React from 'react'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { makeStyles } from 'tss-react/mui';
import { checkProps, dntProps, emailProps, pwdProps, pxToRem } from '@/util';
import { AppColors } from '@/assets/colors';
import EmailIcon from '@mui/icons-material/Email';
import { ArrowBack } from '@mui/icons-material';



export const CheckInput=({isBtn=true,name,btnAction,value=false,handleChange}:Partial<checkProps>)=>{
    const {classes}=styles();
    const label = { inputProps: { "aria-label": "Checkbox demo" } };
    return(
        <Box className={classes.forget}>
        <Box className={classes.check}><Checkbox checked={!!value} {...label} onChange={(e)=>handleChange&&handleChange(e.target.checked)} /><Typography className={classes.checkTxt}>{`${name||'Keep me Logged in'}`}</Typography></Box>
       {isBtn&&<Button onClick={()=>btnAction&&btnAction()}> Forget Password?</Button>}
      </Box>
    )
}
export const NameInput=({name,placeholder}:{name:string,placeholder:string})=>{
    const {classes}=styles();
    return(
<Box className={classes.inputCont}>                        
      <Typography className={classes.label}>{name}</Typography>
      <TextField placeholder={placeholder} fullWidth/>
    </Box>
    )
}
export const BtnInput=({name,btnAction}:{name:string,btnAction?:()=>void})=>{
    const {classes}=styles();
    return(
            <Button onClick={()=>btnAction&&btnAction()} fullWidth variant='contained' className={classes.btn}>{`${name||'Sign In'}`}</Button>
    )
}
export const GoBackBtn=({name,btnAction}:{name:string,btnAction?:()=>void})=>{
  const {classes}=styles();
  return(
          <Button startIcon={<ArrowBack/>} onClick={()=>btnAction&&btnAction()} fullWidth  className={classes.btn}>{`${name||'Sign In'}`}</Button>
  )
}

export const EmailInput=({value,handleChange,error}:Partial<emailProps>)=>{
    const {classes}=styles();
    return(
        <Box className={classes.inputCont}>
        <Typography className={classes.label}>Email Address</Typography>
        <TextField
        value={value||""}
         onChange={(e)=>handleChange&&handleChange(e.target.value)}
         placeholder='Enter Email Address' 
          error={error||false}
        fullWidth    
           InputProps={{
              endAdornment: <InputAdornment position="end">
              <IconButton><EmailIcon/></IconButton>
              </InputAdornment>,
             
            }}
          />
      </Box>
    )
}

export const PasswordInput=({name,placeholder,value,handleChange}:Partial<pwdProps>)=>{
    const {classes}=styles();
    const[isEye,setEye]=React.useState<boolean>(false);
    return(
            <Box className={classes.inputCont}>
              <Typography className={classes.label}>{name||'Password'}</Typography>
              <TextField 
                value={value}
                onChange={(e)=>handleChange&&handleChange(e.target.value)}
                type={!isEye?"password":"text"}
               placeholder={placeholder||'Enter your password'} fullWidth       InputProps={{
                    endAdornment: <InputAdornment position="end">
                    <IconButton onClick={()=>setEye(!isEye)}><VisibilityOffIcon/></IconButton>
                    </InputAdornment>,
                   
                  }}
                />
            </Box>
    )
}


export const DontHave=({actionName,question,btnAction}:Partial<dntProps>)=>{
    const {classes}=styles();
    return(
        <Box className={classes.reg}>
              <Typography className={classes.dhtxt}>{question||'Don’t have account'}</Typography>
              <Button onClick={()=>btnAction&&btnAction()}> {actionName||'Register'}</Button>
            </Box>
    )
}
const styles=makeStyles()((theme)=>({
    inputCont:{
        display:'flex',
        flexDirection:'column',
        gap:theme.spacing(2)
       },
       btn:{
             height:pxToRem(46)
           },
        label:{
             fontWeight: 500,
             fontSize: pxToRem(14),
             color:AppColors.text.default
           },
           forget:{
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between'
            },
            check:{
              display:'flex',
              flexDirection:'row',
              alignItems:'center'
            },
            dhtxt:{
                fontweight: 400,
                fonSize:pxToRem(16)
                
                    },
                    reg:{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      gap:theme.spacing(3)
                       
                    },
                    checkTxt:{
                      fontWeight: 500,
                     fontSize: pxToRem(16),

                    }
}))